<template>
  <v-row justify="center" v-if="my_modulo">
    <v-dialog v-model="dialog" scrollable persistent max-width="90%">
      <v-card>
        <v-card-title>Asignar Docente a Modulo</v-card-title>
        <v-divider class="ma-0"></v-divider>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12">
              <p v-html="datamsg"></p>
              <v-text-field
                autofocus
                v-model="search"
                class="ma-2"
                @input="buscar"
                label="Buscar por C.I ó Nombre"
                hint="Escriba y Seleccione Docente de la lista"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" class="text-center" v-if="my_modulo.docente">
              <!-- si existe docente asignado mostrado aqui -->
              <p>
                <b>Docente Asignado: </b> {{ my_modulo.docente.num_doc }} - {{ my_modulo.docente.nombres }}
                {{ my_modulo.docente.pri_apellido }}
                {{ my_modulo.docente.seg_apellido }}
              </p>
              <p>
                <b>Usuario Moodle: </b> {{ my_modulo.docente.usuario_moodle }} ,<b>Clave Moodle: </b>
                {{ my_modulo.docente.clave_moodle }}
              </p>
              <p v-if="was_assigned" class="text-primary">Este Docente Ya se encuentra Asignado en Moodle</p>
              <v-btn
                v-if="!was_assigned && my_modulo.course_id"
                color="orange"
                outlined
                rounded
                small
                @click="assignTeacherInMoodle(my_modulo.docente)">
                Asignar tambien en moodle
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="search && search.length > 3">
              <v-data-table :headers="headers" :items="teachers" sort-by="full_name">
                <template #[`item.full_name`]="{ item }"
                  >{{ item.nombres }} {{ item.pri_apellido }} {{ item.seg_apellido }}</template
                >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" v-on="on" color="orange" @click="assignTeacherAtSystem(item)"
                        >mdi-plus-outline</v-icon
                      >
                    </template>
                    Asignar Este Docente al Modulo en el Sistema
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined rounded @click="dialog = false">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      //api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      search: null,
      teachers: [],
      headers: [
        // { text: 'id', value: 'id', width: 50 },
        { text: 'N° Documento', value: 'num_doc' },
        { text: 'Nombre Completo', value: 'full_name', sortable: false },
        { text: 'Correo Electronico', value: 'email', width: 120, sortable: false },
        { text: 'Opciones', value: 'actions', sortable: false },
      ],
      dialog: false,
      my_modulo: null,
      was_assigned: false,

      datamsg: '',
      plataforma: {},
      plataformas: [],
      msgerr: '',
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      // programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },

  methods: {
    showThisView(programa_modulo) {
      this.getDatosPlataformas(programa_modulo);
      this.dialog = true;
      this.my_modulo = programa_modulo;
      window.console.log('showThisView', this.my_modulo);
      if (this.my_modulo.docente) this.showDocenteAssigned(this.my_modulo.docente);
      // window.console.log('showThisView', this.my_modulo);
    },
    buscar(query = null) {
      if (query && query.length > 3) {
        let isdocumento = /^\d+$/.test(+query);
        let sql = gql`query{ getPersonasByName(nombres:"${query}"){id num_doc nombres pri_apellido seg_apellido email telefono1 usuario_moodle clave_moodle } }`;
        if (isdocumento)
          sql = gql`query{ getPersonasByDoc(num_doc:"${+query}", estado:true){id num_doc nombres pri_apellido seg_apellido email telefono1 usuario_moodle clave_moodle  } }`;
        this.$apollo
          .query({ query: sql })
          .then(
            ({ data }) =>
              (this.teachers = data && data.getPersonasByName ? data.getPersonasByName : data.getPersonasByDoc),
          );
      }
    },

    assignTeacherAtSystem(docente) {
      this.$root.$confirm.open('Asignar Docente', 'Estas seguro de asignar?', { color: 'orange' }).then((confirm) => {
        if (this.my_modulo && docente && confirm) {
          const sql = gql`mutation{asignarDocente(input:{programa_modulo_id: ${this.my_modulo.id}  docente_id: ${docente.id}}){ ok,  errors{message} programa{id,course_category_id} }}`;
          // window.console.log('mutation asignarDocente ', sql.loc.source.body);
          this.$apollo
            .mutate({ mutation: sql })
            .then(({ data: { asignarDocente } }) => {
              if (asignarDocente.ok) {
                this.$root.$notify.show('Docente Asignado en el Sistema', { color: 'success' });
                this.showDocenteAssigned(docente);
              } else {
                asignarDocente.errors.forEach((error) => this.$root.$notify.show(error.message, { color: 'red' }));
              }
            })
            .catch(() => this.$root.$notify.show('ERROR:  al asignarDocente', { color: 'red' }));
        }
      });
    },
    showDocenteAssigned(docente) {
      this.my_modulo.docente = docente;
      this.search = docente.num_doc;
      if (this.my_modulo.programa.plataforma_id && this.my_modulo.course_id) {
        this.verifyOrCreateUserMoodle(docente);
        //verified if docente was assigned in moodle for this course
        this.verifiedIfWasAssignedInMoodle(docente, this.my_modulo.course_id);
      }
    },

    // verificar si existe y sino crear y luego asignarle como docente en el curso
    verifyOrCreateUserMoodle(docente) {
      this.msgerr = '';
      /*if( !this.plataforma.id ){
          this.getDatosPlataformas();
        }*/
      const plataformaId = this.my_modulo.programa.plataforma_id;
      const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
        /\/$/,
        '',
      )}/plataformas/${plataformaId}/user/uname/${docente.usuario_moodle}`;
      xaxios
        .get(url)
        .then(({ data }) => {
          if (data.suspended) this.$root.$notify.show('Docente Suspendido en Moodle', { color: 'orange' });
        })
        // if error because do not exist then it is created user,
        .catch(() => {
          let userForm = {
            email: docente.email,
            firstname: docente.nombres,
            lastname: `${docente.pri_apellido} ${docente.seg_apellido}`,
            password: docente.clave_moodle,
            phone1: docente.telefono1,
            username: docente.usuario_moodle,
            idnumber: docente.id,
          };
          const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
            /\/$/,
            '',
          )}/plataformas/${plataformaId}/user`;
          // this line create register user in moodle then call verifyOrCreateUserMoodle for assign teacher
          xaxios.post(url, userForm).then(() => this.verifyOrCreateUserMoodle(docente));
        });
    },
    verifiedIfWasAssignedInMoodle(docente, course_id) {
      // TODO: debe existir un endpoint que me retorne si este usuario esta como docente en un curso determinado
      const url = `${this.plataforma.direccion}/esam/user/uname/${docente.usuario_moodle}/course/id/${course_id}`;
      window.console.log('verifiedIfWasAssignedInMoodle', url);
      // axios.get(url).then(() => (this.was_assigned = true)); TODO: descomentar cuando exista el endpoint
    },

    assignTeacherInMoodle(docente) {
      const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.plataforma.id
      }/enrolment`;
      let userForm = { username: docente.usuario_moodle, course_id: this.my_modulo.course_id, user_role: 3 };
      xaxios
        .post(url, userForm)
        .then(() => this.$root.$notify.show(`Docente Asignado Exitosamente en Moodle`, { color: 'success' }))
        .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'red', x: 'right' }));

      this.closeDialog();
    },

    closeDialog() {
      this.dialog = false;
      this.my_modulo = null;
      this.search = null;
      this.was_assigned = false;
    },

    getDatosPlataformas(programa_modulo) {
      window.console.log('getDatosPlataformas', programa_modulo);
      this.$apollo
        .query({
          query: gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          let plataforma_id = programa_modulo.programa.plataforma_id;
          this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
          this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
        })
        .catch((err) => {
          this.$root.$notify.show(`ERROR: getPlataformas(DialogAssignTeacher) ${err}`);
        });
    },
  },
  mounted() {
    //this.getDatosPlataformas();
  },
};
</script>
